export default __webpack_public_path__ + "static/media/CyclingCanada.2818be5b.png";